import script from "./SmsLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsLogin.vue?vue&type=script&setup=true&lang=js"

import "./SmsLogin.vue?vue&type=style&index=0&id=f97145a4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f97145a4"]])

export default __exports__